import { useState } from "react";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import { AddVideosHooks } from "../../screens/Videos/hooks/VideosHooks";
import DropdownWithTags from "../universal/DropdownWithTags";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import LanguageDrawer from "../universal/LanguageDrawer";

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import { FaInfoCircle } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import RelatedVideoInput from "../categories/RelatedVideoInput";
import VideoLibraryModal from "../TWG/VideoLibraryModal";
import { toast } from "react-toastify";
const AddVideosFields = ({ setLoading, data }) => {
  // const { options } = GetRelatedVideosHooks();

  const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    videoInputs,
    videoErrors,
    videoUrlsInputs,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    handleSendNotification
  } = AddVideosHooks(setLoading, data);

  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");

        const isEmpty = (value) =>
    value === undefined || value === null || value.toString().trim() === "";
  const validateAllRequiredFields = () => {
    if (isEmpty(videoInputs?.video_title)) {
      toast.error("Campus Title is required");
      return false;
    }

    if (isEmpty(videoInputs?.video_description)) {
      toast.error("Short Description is required");
      return false;
    }

    if (isEmpty(videoInputs?.video_description)) {
      toast.error("Long Description is required");
      return false;
    }

    if (!tumbNailUrlsInputs?.webUploadUrl) {
      toast.error("Campus Logo is required");
      return false;
    }

    if (isEmpty(videoInputs?.upcoming_programs)) {
      toast.error("Upcoming Program is required");
      return false;
    }

    if (isEmpty(videoInputs?.upcoming_events)) {
      toast.error("Upcoming Event is required");
      return false;
    }

    if (isEmpty(videoInputs?.ministries)) {
      toast.error("Ministry is required");
      return false;
    }

    if (isEmpty(videoInputs?.carecells)) {
      toast.error("Carecell is required");
      return false;
    }

    if (isEmpty(videoInputs?.campuses)) {
      toast.error("Campus selection is required");
      return false;
    }

    if (isEmpty(videoInputs?.team)) {
      toast.error("Team is required");
      return false;
    }

    return true;
  };

  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Campus"
                  : `Translate Campus to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={() => {
                        if (!validateAllRequiredFields()) return;
                        handleSave();
                      }}

                    >
                      {videoInputs?._id ? "Update Campus" : "Save Campus"}
                    </button>
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && !data?._id ? (
              <div className="flex items-center justify-center text-white gap-1 py-28">
                Campus translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved Campus
              </div>
            ) : (
              <div className="px-4 my-4 h-full">
                <div className=" overflow-y-auto overflow-x-hidden">
                  <div className="grid md:grid-cols-2 grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 mx-1 w-full">
                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="campus_title"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        Campus Title *
                        <FaInfoCircle
                          data-tooltip-id="add_campus"
                          data-tooltip-content="Enter the Campus Title"
                        />
                      </label>
                      <input
                        name="campus_title"
                        placeholder="Enter Campus Title"
                        type="text"
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 `}
                        // value={inputs[activeTab]?.categoryCode}
                        value={videoInputs?.video_title}
                        onChange={handleChange}
                      />
                      {videoErrors?.video_title && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Campus Title Is Required Field
                        </p>
                      )}
                    </div>
                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="campus_short_description"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        Short Description *
                        <FaInfoCircle
                          data-tooltip-id="add_campus"
                          data-tooltip-content="Enter the Campus Description"
                        />
                      </label>
                      <textarea
                        rows={6}
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md`}
                        name="campus_short_description"
                        placeholder="Enter Short Description"
                        // value={inputs[activeTab]?.videoDescription}
                        // onChange={handleVideoDescriptionChange}
                        value={videoInputs?.video_description}
                        onChange={handleChange}
                      />
                      {videoErrors?.video_description && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Campus Description Is Required Field
                        </p>
                      )}
                    </div>
                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="campus_long_description"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        Long Description *
                        <FaInfoCircle
                          data-tooltip-id="add_campus"
                          data-tooltip-content="Enter the campus Description"
                        />
                      </label>
                      <textarea
                        rows={6}
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md`}
                        name="campus_long_description"
                        placeholder="Enter Long Description"
                        // value={inputs[activeTab]?.videoDescription}
                        // onChange={handleVideoDescriptionChange}
                        value={videoInputs?.video_description}
                        onChange={handleChange}
                      />
                      {videoErrors?.video_description && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Campus Description Is Required Field
                        </p>
                      )}
                    </div>
                    {activeTab === "en" && (
                      <>
                        <UploadControlsV2
                          tooltipTitle="Upload Campus Logo"
                          className="my-2 col-span-2 mr-1"
                          title="Campus Logo *"
                          subtitle="Upload Image"
                          handleChangeUrl={(event) =>
                            handleInputChange(event, setTumbNailUrlsInputs)
                          }
                          mobileUploadProgressId="mobileUploadUrlAddVideoVideoThumbnailURL"
                          handleMobileFileUpload={(e) =>
                            handleFileInputChange(
                              setTumbNailUrlsInputs,
                              "mobileUploadUrl",
                              e.target.files[0],
                              null,
                              "mobileUploadUrlAddVideoVideoThumbnailURL",
                              false,
                              "video_thumbnails_urls"
                            )
                          }
                          mobileUploadUrl={tumbNailUrlsInputs?.mobileUploadUrl}
                          handleMobilePreview={() => {
                            setIsImage(false);
                            setShowModal(true);
                            setCurrentUrl(tumbNailUrlsInputs?.mobileUploadUrl);
                          }}
                          tabletUploadProgressId="tabletUploadUrlAddVideoVideoThumbnailURL"
                          handleTabletFileUpload={(e) =>
                            handleFileInputChange(
                              setTumbNailUrlsInputs,
                              "tabletUploadUrl",
                              e.target.files[0],
                              null,
                              "tabletUploadUrlAddVideoVideoThumbnailURL",
                              false,
                              "video_thumbnails_urls"
                            )
                          }
                          tabletUploadUrl={tumbNailUrlsInputs?.tabletUploadUrl}
                          handleTabletPreview={() => {
                            setIsImage(true);
                            setShowModal(true);
                            setCurrentUrl(tumbNailUrlsInputs?.tabletUploadUrl);
                          }}
                          webUploadProgressId="webUploadUrlAddVideoVideoThumbnailURL"
                          handleWebFileUpload={(e) =>
                            handleFileInputChange(
                              setTumbNailUrlsInputs,
                              "webUploadUrl",
                              e.target.files[0],
                              null,
                              "webUploadUrlAddVideoVideoThumbnailURL",
                              false,
                              "video_thumbnails_urls"
                            )
                          }
                          webUploadUrl={tumbNailUrlsInputs?.webUploadUrl}
                          handleWebPreview={() => {
                            setIsImage(true);
                            setShowModal(true);
                            setCurrentUrl(tumbNailUrlsInputs?.webUploadUrl);
                          }}
                          isFieldRequired={videoErrors?.video_thumbnails_urls}
                          requiredMessage="Campus Logo Is Required Field"
                        />
                      </>
                    )}


                  </div>
                </div>
                {/* Upcoming Programs */}
<div className="md:col-span-2 col-span-1">
  <label
    htmlFor="upcoming_programs"
    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
  >
    Select Upcoming Programs *
    <FaInfoCircle
      data-tooltip-id="add_ministry"
      data-tooltip-content="Select upcoming program"
    />
  </label>
  <select
    name="upcoming_programs"
    className="bg-blackishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-lg border border-opacity-10 border-white  h-10"
    value={videoInputs?.upcoming_programs || ""}
    onChange={handleChange}
  >
    <option value="">-- Select Program --</option>
    <option value="program1">Program 1</option>
    <option value="program2">Program 2</option>
  </select>
  {videoErrors?.upcoming_programs && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      This field is required
    </p>
  )}
</div>

{/* Upcoming Events */}
<div className="md:col-span-2 col-span-1">
  <label
    htmlFor="upcoming_events"
    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
  >
    Select Upcoming Events *
    <FaInfoCircle
      data-tooltip-id="add_ministry"
      data-tooltip-content="Select upcoming event"
    />
  </label>
  <select
    name="upcoming_events"
    className="bg-blackishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-lg border border-opacity-10 border-white  h-10"
    value={videoInputs?.upcoming_events || ""}
    onChange={handleChange}
  >
    <option value="">-- Select Event --</option>
    <option value="event1">Event 1</option>
    <option value="event2">Event 2</option>
  </select>
</div>

{/* Ministries */}
<div className="md:col-span-2 col-span-1">
  <label
    htmlFor="ministries"
    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
  >
    Select Ministries *
  </label>
  <select
    name="ministries"
    className="bg-blackishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-lg border border-opacity-10 border-white  h-10"
    value={videoInputs?.ministries || ""}
    onChange={handleChange}
  >
    <option value="">-- Select Ministry --</option>
    <option value="ministry1">Ministry 1</option>
    <option value="ministry2">Ministry 2</option>
  </select>
</div>

{/* Carecells */}
<div className="md:col-span-2 col-span-1">
  <label
    htmlFor="carecells"
    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
  >
    Select Carecells *
  </label>
  <select
    name="carecells"
    className="bg-blackishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-lg border border-opacity-10 border-white  h-10"
    value={videoInputs?.carecells || ""}
    onChange={handleChange}
  >
    <option value="">-- Select Carecell --</option>
    <option value="carecell1">Carecell 1</option>
    <option value="carecell2">Carecell 2</option>
  </select>
</div>

{/* Campuses */}
<div className="md:col-span-2 col-span-1">
  <label
    htmlFor="campuses"
    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
  >
    Select Campuses *
  </label>
  <select
    name="campuses"
    className="bg-blackishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-lg border border-opacity-10 border-white  h-10"
    value={videoInputs?.campuses || ""}
    onChange={handleChange}
  >
    <option value="">-- Select Campus --</option>
    <option value="campus1">Campus 1</option>
    <option value="campus2">Campus 2</option>
  </select>
</div>

{/* Team */}
<div className="md:col-span-2 col-span-1">
  <label
    htmlFor="team"
    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
  >
    Select Team *
  </label>
  <select
    name="team"
    className="bg-blackishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-lg border border-opacity-10 border-white  h-10"
    value={videoInputs?.team || ""}
    onChange={handleChange}
  >
    <option value="">-- Select Team --</option>
    <option value="team1">Team 1</option>
    <option value="team2">Team 2</option>
  </select>
</div>

                {activeTab === "en" && (
                  <>
                    <RelatedVideoInput
                      categoryErrors={videoErrors}
                      setShowVideoLibraryModal={setShowVideoLibraryModal}
                      handleDropdownChange={handleDropdownChange}
                      selectedOptions={selectedOptions}
                      deleteRelatedVideo={deleteRelatedVideo}
                      showVideoOrder={false}
                      setSelectedOptions={setSelectedOptions}
                      setSelectedRelatedVideoIndex={setSelectedRelatedVideoIndex}
                      isFieldRequired={false}
                      videoLabelClassName={"col-span-2"}
                    />
                    <VideoLibraryModal
                      showVideoLibraryModal={showVideoLibraryModal}
                      setShowVideoLibraryModal={setShowVideoLibraryModal}
                      handleVideoSelection={handleDropdownChange}
                    />
                  </>
                )}
              </div>
            )}
            <Tooltip id="add_ministry" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{videoInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{videoInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for video</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this video to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedVideos" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />

                    {layoutInfo && (
                      <>
                        <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                              value={layoutValues?.order}
                              onChange={handleVideoLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>
      <ReactModal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
        <div className="flex justify-center h-full w-full relative">
          <div
            className="absolute top-0 right-0 cursor-pointer"
            onClick={() => setShowModal(false)}
          >
            <ImCross />
          </div>
          {isImage ? (
            <img className="h-full" src={currentUrl} />
          ) : (
            <video className="h-full" controls autoPlay>
              <source src={currentUrl} />
            </video>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AddVideosFields;
